import $ from 'jquery';
import { sliderConfigs } from 'js/utils/settings';
import HoverIntent from 'js-hoverintent';

export default class Slider {
  constructor(element, options) {
    this.element = element;
    this.settings = { ...sliderConfigs.defaults, ...options };
    this.slider = this.build();
    this.dotsAreHoverable();
    this.ready();
  }

  build() {
    return $(this.element).slick(this.settings);
  }

  dotsAreHoverable() {
    if (this.settings.advanceOnDotsHover) {
      this.element.classList.add('slick-dots-are-hoverable');
    }
  }

  ready() {
    this.element.classList.add('ready');
    const enterIntent = new HoverIntent(
      '.slick-dots-are-hoverable .slick-dots li',
      (event) => $(event.target).click(),
      () => {},
    );
  }
}
